import Util from "../lib/util.js";
import geodesic from "./../lib/geodesic.js";
import { RepositoryFactory } from "./../repository/RepositoryFactory";
import Logger from "./../lib/logger";
import { makeCancellable, takeLatest } from "vuex-cancellable-actions";
import SwinFnc from "./../lib/SwinFnc.js";

/** Repository */
const SwinRepository = RepositoryFactory.get("swin");

export default {
  namespaced: true,
  state: {
    /** 横断設定 */
    crossConfig: {},
    /** 選択中危機管理型水位計情報 */
    selectedSw: [],
    selectedSwParam: {
      /** 事務所コード */
      swofcCd: null,
      /** 観測所種別コード */
      itmkndCd: null,
      /** 危機管理型水位観測所ID */
      swobsCd: null,
      /** 選択中危機管理型河川カメラID */
      swcctvCd: null,
    },
    /** 横断設定情報 */
    surfaceConf: {},
    /** 横断データ */
    surface: {},
    /** 地点登録 選択中危機管理型水位計情報  */
    swSelectedPointData: {},
    /** 地点登録 選択中危機カメラ情報  */
    swSelectedPointCctvData: {},
    /** 地点登録 選択中簡易カメラ情報  */
    swSelectedPointScamData: {},
    /** 横断図SVGエラー */
    swCrossSvgError: false,
    /** アクセスログ出力用パラメータ */
    pageLogParam: null,
  },
  mutations: {
    /**
     * 選択中危機管理型水位計情報パラメータ(カメラなし)
     * @param {*} state
     * @param {*} selectedSw 選択中の危機管理型水位計情報
     */
    setSelectedSwParam(state, selectedSw) {
      Logger.debug(
        "[Swin]mut - setSelectedTmParam(" +
          selectedSw.swofcCd +
          "," +
          selectedSw.itmkndCd +
          "," +
          selectedSw.swobsCd +
          ")"
      );
      state.selectedSwParam = selectedSw;
    },
    /**
     * 選択中危機管理型水位計情報パラメータ(カメラあり)
     * @param {*} state
     * @param {*} selectedSw 選択中の危機管理型水位計情報
     */
    setSelectedSwParamCctv(state, selectedSw) {
      Logger.debug(
        "[Swin]mut - setSelectedTmParamCctv(" +
          selectedSw.mtSwobs.obsInfo.swofcCd +
          "," +
          selectedSw.mtSwobs.obsInfo.itmkndCd +
          "," +
          selectedSw.mtSwobs.obsInfo.swcctvCd +
          ")"
      );
      state.selectedSwParam = selectedSw;
    },
    /**
     * 横断設定
     * @param {*} state
     * @param {*} crossConfig
     */
    setCrossConfig(state, crossConfig) {
      Logger.debug("[Swin]mut - setCrossConfig(state, crossConfig)");
      Logger.dir(crossConfig);
      state.crossConfig = crossConfig;
    },
    /**
     * 選択中危機管理型水位計マスタ情報設定
     * @param {*} state
     * @param {*} selectedMtSwobs 選択中危機管理型水位計マスタ情報
     */
    setSelectedMtSwobs(state, selectedMtSwobs) {
      Logger.debug("[Swin]mut - setSelectedMtSwobs(state, selectedMtSwobs)");
      Logger.dir(selectedMtSwobs);
      state.selectedMtSwobs = selectedMtSwobs;
    },
    /**
     * 選択中危機管理型水位計情報設定
     * @param {*} state
     * @param {*} selectedSw 選択中危機管理型水位計情報
     */
    setSelectedSw(state, selectedSw) {
      Logger.debug("[Swin]mut - setSelectedSw(state, selectedSw)");
      Logger.dir(selectedSw);
      state.selectedSw = selectedSw;
    },
    /** 横断設定情報設定 */
    setSurfaceConf(state, surfaceConf) {
      Logger.debug("[Swin]mut - setSurfaceConf(state, surfaceConf)");
      Logger.dir(surfaceConf);
      state.surfaceConf = surfaceConf;
    },
    /** 横断データ設定 */
    setSurface(state, surface) {
      Logger.debug("[Swin]mut - setSurface(state, surface)");
      Logger.dir(surface);
      state.surface = surface;
    },
    /** 地点登録 選択中危機管理型水位計情報を設定 */
    setSwSelectedPointData(state, swSelectedPointData) {
      Logger.debug(
        "[Swin]mut - setSwSelectedPointData(state, swSelectedPointData)"
      );
      Logger.dir(swSelectedPointData);
      state.swSelectedPointData = swSelectedPointData;
    },
    /** 地点登録 選択中危機カメラ情報を設定 */
    setSwSelectedPointCctvData(state, swSelectedPointCctvData) {
      Logger.debug(
        "[Swin]mut - setSwSelectedPointCctvData(state, swSelectedPointCctvData)"
      );
      Logger.dir(swSelectedPointCctvData);
      state.swSelectedPointCctvData = swSelectedPointCctvData;
    },
    /** 地点登録 選択中簡易カメラ情報を設定 */
    setSwSelectedPointScamData(state, swSelectedPointScamData) {
      Logger.debug(
        "[Swin]mut - setSwSelectedPointScamData(state, swSelectedPointScamData)"
      );
      Logger.dir(swSelectedPointScamData);
      state.swSelectedPointScamData = swSelectedPointScamData;
    },
    /** 横断図SVGエラー情報設定 */
    setSwCrossSvgError(state, swCrossSvgError) {
      Logger.debug(
        "[Telemeter]mut - setSwCrossSvgError(" + swCrossSvgError + ")"
      );
      state.swCrossSvgError = swCrossSvgError;
    },
    /** アクセスログ出力用パラメータ設定 */
    setPageLogParam(state, pageLogParam) {
      Logger.debug("[Swin]mut - setPageLogParam(pageLogParam)");
      Logger.dir(pageLogParam);
      state.pageLogParam = pageLogParam;
    },
  },
  actions: makeCancellable({
    /**
     * 選択された危機管理型水位計の情報を取得
     * @param {*}
     * @param {*} swobsCd 危機管理型水位計番号
     * @param {*} isCurrent 観測日時 [true:最新, false:履歴]
     * @param {*} appTime 取得対象の時刻
     * @param appTimeRound 観測日時(ファイル取得用)
     */
    getSelectedSw: takeLatest(async function(
      { commit },
      { swobsCd, isCurrent, appTime, appTimeRound }
    ) {
      Logger.debug(
        "[Swin]act - getSelectedSw({*},{" +
          appTime +
          "," +
          swobsCd +
          "," +
          isCurrent +
          "}"
      );

      // 危機管理型水位計マスタ情報を取得
      const { data: mtSwobs } = await SwinRepository.getSelectedMtSwobs(
        swobsCd
      );
      Logger.debug("[Swin]act - getSelectedSw - mtSwobs");
      Logger.dir(mtSwobs);

      // アクセスログ出力用パラメータ格納
      commit("setPageLogParam", {
        swobsCd: swobsCd,
        appTime: appTimeRound,
        obsData: mtSwobs,
      });

      // 危機管理型水位計情報を取得
      const { error, data: swStg } = await SwinRepository.getSelectedSwstg(
        swobsCd,
        appTimeRound
      );

      let min10Values = [];
      if (!error) {
        // 0時表記を24時表記に変更する
        min10Values = swStg.min10Values;
        let time, date;
        for (let idx in swStg.min10Values) {
          let tmpDate = swStg.min10Values[idx].obsTime.split(" ");
          date = tmpDate[0];
          time = tmpDate[1];
          if (tmpDate[1] == "00:00") {
            date = Util.formatDate(Util.subDays(tmpDate[0], 1), "YYYY/MM/DD");
            time = "24:00";
          }
          min10Values[idx].obsTime = date + " " + time;
        }
      }

      let result = {};
      result = SwinFnc.convertObsSwStg(
        // 危機管理水位観測所情報
        mtSwobs,
        // 最新危機管理水位観測値情報
        !error && swStg ? swStg.obsValue : null,
        // [グラフ用]観測値リスト
        !error && swStg ? min10Values : [],
        // 画面表示時刻
        Util.formatDate(appTime)
      );

      // 取得情報をストアに格納
      commit("setSelectedSw", result);
    }),
    /**
     * 地点登録の選択中危機管理型水位計として登録する情報を取得
     * @param {*} param0
     * @param {*} param1
     */
    async getSwSelectedPointData({ commit }, { swobsCd, distance }) {
      Logger.debug("[Swin]act - getSwSelectedPointData({*},{" + swobsCd + "}");

      // 危機管理型水位計マスタ情報を取得
      const { data: mtSwobs } = await SwinRepository.getSelectedMtSwobs(
        swobsCd
      );
      Logger.debug("[Swin]act - getSwSelectedPointData - mtSwobs");
      Logger.dir(mtSwobs.obsInfo);

      // パラメータをデータに追加
      mtSwobs.obsInfo.distance = distance;

      // 情報をストアに格納
      commit("setSwSelectedPointData", mtSwobs.obsInfo);
    },
    /**
     * 地点登録の選択中簡易カメラとして登録する情報を取得
     * @param {*} param0
     * @param {*} param1
     */
    async getSwSelectedPointScamData(
      { commit },
      { scamId, lat, lon, distance }
    ) {
      Logger.debug(
        "[Swin]act - getSwSelectedPointScamData({*},{" + scamId + "}"
      );
      // 簡易カメラ情報を取得
      const { data: mtScam } = await SwinRepository.getSelectedScam(scamId);
      Logger.debug("[Swin]act - getSwSelectedPointScamData - mtScam");
      Logger.dir(mtScam);

      // パラメータをデータに追加
      mtScam.obsInfo.scamId = scamId;
      mtScam.obsInfo.lat = lat;
      mtScam.obsInfo.lon = lon;
      mtScam.obsInfo.distance = distance;

      // 情報をストアに格納
      commit("setSwSelectedPointScamData", mtScam.obsInfo);
    },
    /**
     * 横断設定情報取得
     * @param {*}
     * @param {*} swobsCd 危機管理型水位計番号
     */
    async getSurfaceData(
      { state, commit },
      { distanceP, point1Info, point2Info, point3Info, point4Info, point5Info }
    ) {
      Logger.debug("[Swin]act - getSurfaceData()");
      Logger.debug("[Swin]act - getSurfaceData() distanceP");
      Logger.dir(distanceP);
      Logger.debug("[Swin]act - getSurfaceData() point1Info");
      Logger.dir(point1Info);
      Logger.debug("[Swin]act - getSurfaceData() point2Info");
      Logger.dir(point2Info);
      Logger.debug("[Swin]act - getSurfaceData() point3Info");
      Logger.dir(point3Info);
      Logger.debug("[Swin]act - getSurfaceData() point4Info");
      Logger.dir(point4Info);
      Logger.debug("[Swin]act - getSurfaceData() point5Info");
      Logger.dir(point5Info);

      let mtSwobs = state.selectedSw.mtSwobs;
      mtSwobs.drawType = mtSwobs.obsInfo.drawType;

      // 水位の観測値を設定
      // 堤防天端からの高さに変換
      for (const swStg of state.selectedSw.swStg) {
        swStg.elevation = swStg.stg;
      }
      mtSwobs.stages = state.selectedSw.swStg;
      mtSwobs.trPredStg = [];

      Logger.debug("[Swin]act - getSurfaceData() mtSwobs");
      Logger.dir(mtSwobs);

      let swcrs = mtSwobs.crs;
      Logger.debug("[Swin]act - getSurfaceData() swcrs");
      Logger.dir(swcrs);

      let conf = {
        dispAB: false,
        locationA: [],
        locationB: [],
        dispP: false,
        locationP: [],
      };

      // 横断データの有無
      var isCross = false;
      // 左右岸緯度経度の有無
      var isBnk = false;

      // 描画なし以外の場合
      if (mtSwobs.drawType !== 0) {
        // 横断マスタ、横断断面マスタがある場合
        if (
          swcrs != null &&
          swcrs.sfLeftLimit != null &&
          swcrs.sfRghtLimit != null
        ) {
          Logger.debug(
            "[Swin]act - getSurfaceData() 横断マスタ、横断断面マスタがある isCross = true"
          );
          isCross = true;
        }

        // 左右岸緯度経度が全て揃っている場合
        if (
          mtSwobs.obsInfo.leftBnkLat &&
          mtSwobs.obsInfo.leftBnkLat != null &&
          mtSwobs.obsInfo.leftBnkLon &&
          mtSwobs.obsInfo.leftBnkLon != null &&
          mtSwobs.obsInfo.rightBnkLat &&
          mtSwobs.obsInfo.rightBnkLat != null &&
          mtSwobs.obsInfo.rightBnkLon &&
          mtSwobs.obsInfo.rightBnkLon != null
        ) {
          Logger.debug(
            "[Swin]act - getSurfaceData() 左右岸緯度経度が全て揃っている isBnk = true"
          );
          isBnk = true;
        }

        if (!isCross && !isBnk) {
          // 横断データ・左右岸緯度経度がない場合は描画なしとする
          Logger.debug(
            "[Swin]act - getSurfaceData() 横断データ・左右岸緯度経度がない場合は描画なし stgobs.drawType = 0"
          );
          mtSwobs.drawType = 0;
        }
      }

      // 横断描画なし、特殊横断の場合はストアに格納して終了
      if (mtSwobs.drawType === 0 || mtSwobs.drawType === 2) {
        Logger.debug(
          "[Swin]act - getSurfaceData() 横断描画なし、特殊横断の場合はストアに格納して終了"
        );
        // 横断表示設定をストアに格納
        commit("setSurfaceConf", conf);
        // 横断データをストアに格納
        commit("setSurface", mtSwobs);
        return;
      }

      // 川幅を設定
      mtSwobs.rvrwid = geodesic.getDistance(
        [mtSwobs.obsInfo.leftBnkLat, mtSwobs.obsInfo.leftBnkLon],
        [mtSwobs.obsInfo.rightBnkLat, mtSwobs.obsInfo.rightBnkLon]
      );
      Logger.debug(
        "[Swin]act - getSurfaceData() 川幅を設定 stgobs.rvrwid = " +
          mtSwobs.rvrwid
      );

      if (mtSwobs.drawType === 1) {
        Logger.debug("[Swin]act - getSurfaceData() 通常横断を描画時の情報取得");
        // A点B点座標を取得
        let endPoint = geodesic.getTmEndPoint(
          [mtSwobs.obsInfo.leftBnkLat, mtSwobs.obsInfo.leftBnkLon],
          [mtSwobs.obsInfo.rightBnkLat, mtSwobs.obsInfo.rightBnkLon],
          mtSwobs.rvrInWid,
          state.crossConfig.riverSideMinWidth
        );
        conf.dispAB = true;
        conf.locationA = endPoint.locationA;
        conf.locationB = endPoint.locationB;

        Logger.debug("[Swin]act - getSurfaceData() A点座標");
        Logger.dir(conf.locationA);
        Logger.debug("[Swin]act - getSurfaceData() B点座標");
        Logger.dir(conf.locationB);

        var result = {
          distance: 0,
          dispP: 0,
          locationP: [],
        };

        // 地点情報を配列化
        var points = [point1Info, point2Info, point3Info, point4Info, point5Info];
        // AB点と地点1～5の最短距離を算出
        for (var idx = 0; idx < points.length; idx++) {
          if (points[idx] != null && points[idx].center != null) {
            // A点～地点間の距離を算出
            var disAP = geodesic.getDistance(
              points[idx].center,
              conf.locationA
            );
            if (
              disAP < distanceP &&
              (result.distance === 0 || disAP < result.distance)
            ) {
              result.distance = disAP;
              result.dispP = 1;
              result.locationP = points[idx].center;
            }
            // B点～地点間の距離を算出
            var disBP = geodesic.getDistance(
              points[idx].center,
              conf.locationB
            );
            if (
              disBP < distanceP &&
              (result.distance === 0 || disBP < result.distance)
            ) {
              result.distance = disBP;
              result.dispP = 2;
              result.locationP = points[idx].center;
            }
          }
        }
        Logger.debug(
          "[Swin]act - getSurfaceData() 閾値範囲内にあるAB点との最短登録地点の情報"
        );
        Logger.dir(result);

        if (result.distance > 0) {
          var locA = [conf.locationA[1], conf.locationA[0]];
          var locB = [conf.locationB[1], conf.locationB[0]];
          var locP = [result.locationP[1], result.locationP[0]];

          // 登録地点がAB間の内側にあるかをチェック
          let isPresentIn = geodesic.checkPresent(locA, locB, locP);
          // 内側にある場合はAB点からの線を描画しない
          if (!isPresentIn) {
            Logger.debug(
              "[Swin]act - getSurfaceData() 登録地点がAB間の内側にある場合 result.dispP = 3"
            );
            result.dispP = 3;
          }

          // 登録地点の表示内容を設定
          conf.dispP = result.dispP;
          conf.locationP = result.locationP;

          Logger.debug("[Swin]act - getSurfaceData() 登録地点の表示内容を設定");
          Logger.dir(conf);
        }

        // 横断表示設定をストアに格納
        commit("setSurfaceConf", conf);
        // 横断データをストアに格納
        commit("setSurface", mtSwobs);
      }
    },
  }),
  getters: {},
};
